import React, { useEffect, useState } from "react";
import BigModal from "./BigModal";
import Icon from "../Icon";
import { formatNumberWithCommas } from "../../utils/helper";
import { getProviderContracts } from "../../features/user/userSlice";
import { useSelector } from "react-redux";
import Button from "../Button";
import { use } from "react";

const ViewContractModal = ({ setCloseModal, closeModal, selectedRow }) => {
  console.log(selectedRow, "selectedRow");

  //   const providerEmail = user?.data?.email || "";
  const id = selectedRow?.id;
  const [providerContract, setProviderContract] = useState({});
  const [categoryOptions, setCategoryOptions] = useState([]);

  useEffect(() => {
    setProviderContract(selectedRow);
  }, [id]);

  // Update initial state
  const [initialData, setInitailData] = useState({});
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [addServiceSuccessful, setAddServiceSuccessful] = useState(false);
  const [openServiceTypeId, setOpenServiceTypeId] = useState(1);
  const [step, setStep] = useState(initialData.step || 1);
  const [selectedCategory, setSelectedCategory] = useState();
  const [showCategoryOptions, setShowCategoryOptions] = useState(false);

  // Update localStorage effect

  useEffect(() => {
    if (providerContract?.providerCategories?.length > 0) {
      setCategoryOptions(providerContract?.providerCategories);
    } else {
      setCategoryOptions(["LAB", "GYM", "SPA"]);
    }
  }, [providerContract?.providerCategories]);

  useEffect(() => {
    setStep(initialData?.step);
  }, [initialData?.step]);

  useEffect(() => {
    if (providerContract?.providerCategories?.length > 0) {
      setSelectedCategory(
        providerContract?.providerCategories?.[0]?.toUpperCase()
      );
    }
  }, [providerContract?.providerCategories?.length]);

  useEffect(() => {
    setInitailData(
      providerContract?.id
        ? {
            serviceTypes: providerContract?.serviceOfferings?.map(
              (service) => ({
                id: service?.serviceCategory?.id,
                serviceType: service?.serviceCategory?.category,
                services: service?.serviceOfferings?.map((offerings) => ({
                  serviceType: offerings?.name,
                  serviceName: offerings?.name,
                  amount: offerings?.price,
                })),
              })
            ),
            gymAmount: String(providerContract?.pricePerVisit),
            step: 2,
            category: providerContract?.providerCategories[0]?.toUpperCase(),
          }
        : {
            serviceTypes: [
              {
                id: 1,
                serviceType: "",
                services: [{ serviceType: "", serviceName: "", amount: "" }],
              },
            ],
            gymAmount: "",
            step: 1,
            category: categoryOptions[0],
          }
    );
  }, [providerContract?.id]);

  // Clear storage when providerEmail changes

  useEffect(() => {
    setFormData(initialData);
  }, [initialData]);

  const addNewServiceType = () => {
    const newId = Math.max(...formData.serviceTypes.map((st) => st.id), 0) + 1;
    setFormData((prev) => ({
      ...prev,
      serviceTypes: [
        ...prev.serviceTypes,
        {
          id: newId,
          serviceType: "",
          services: [{ serviceType: "", serviceName: "", amount: "" }],
        },
      ],
    }));
    setOpenServiceTypeId(newId);
  };

  const toggleServiceType = (id) => {
    setOpenServiceTypeId(openServiceTypeId === id ? null : id);
  };

  console.log(openServiceTypeId, "openServiceTypeId");

  const validateForm = (values) => {
    const errors = {};

    if (selectedCategory === "GYM") {
      if (!values.gymAmount?.trim()) {
        errors.gymAmount = "Amount is required";
      } else if (isNaN(values.gymAmount) || parseFloat(values.gymAmount) <= 0) {
        errors.gymAmount = "Please enter a valid amount";
      }
    } else {
      values.serviceTypes.forEach((serviceTypeObj) => {
        if (!serviceTypeObj?.serviceType?.trim()) {
          errors[`serviceType-${serviceTypeObj.id}`] =
            "Service type is required";
        }

        // Check if service type has at least one valid service

        serviceTypeObj.services.forEach((service, index) => {
          console.log(service);
          if (!service?.serviceName?.trim()) {
            errors[`serviceName-${serviceTypeObj.id}-${index}`] =
              "Service name is required";
          }
          if (!String(service?.amount).trim()) {
            errors[`amount-${serviceTypeObj.id}-${index}`] =
              "Amount is required";
          } else if (
            isNaN(service?.amount) ||
            parseFloat(service?.amount) <= 0
          ) {
            errors[`amount-${serviceTypeObj.id}-${index}`] =
              "Please enter a valid amount";
          }
        });

        console.log(serviceTypeObj.id);
      });
    }
    return errors;
  };

  useEffect(() => {
    setOpenServiceTypeId(formData?.serviceTypes?.[0]?.id);
  }, [formData?.serviceTypes?.length]);

  const handleChange = (e, serviceTypeId, serviceIndex = null) => {
    setErrors({});
    const { name, value } = e.target;

    console.log(serviceTypeId);

    // Handle gymAmount case
    if (name === "gymAmount") {
      setFormData((prev) => ({
        ...prev,
        gymAmount: value,
      }));
    } else {
      // Existing service type handling
      setFormData((prev) => {
        const updatedServiceTypes = prev.serviceTypes.map((st) => {
          if (st.id === serviceTypeId) {
            if (name === "serviceType") {
              return {
                ...st,
                serviceType: value,
              };
            } else if (serviceIndex !== null) {
              const updatedServices = [...st.services];
              updatedServices[serviceIndex] = {
                ...updatedServices[serviceIndex],
                [name]: value,
              };
              return {
                ...st,
                services: updatedServices,
              };
            }
          }
          return st;
        });

        return {
          ...prev,
          serviceTypes: updatedServiceTypes,
        };
      });
    }

    const newErrors = validateForm(formData);
    setErrors(newErrors);
  };

  const handleBlur = (e, serviceTypeId, serviceIndex = null) => {
    const { name } = e.target;

    // Handle gymAmount case
    if (name === "gymAmount") {
      setTouched((prev) => ({
        ...prev,
        gymAmount: true,
      }));
    } else if (name === "serviceType") {
      setTouched((prev) => ({
        ...prev,
        [`serviceType-${serviceTypeId}`]: true,
      }));
    } else if (serviceIndex !== null) {
      setTouched((prev) => ({
        ...prev,
        [`${name}-${serviceTypeId}-${serviceIndex}`]: true,
      }));
    }

    const newErrors = validateForm(formData);
    setErrors(newErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCloseModal(false);
  };

  const handleCategoryChange = (option) => {
    setSelectedCategory(option?.toUpperCase());
    setShowCategoryOptions(false);
  };

  return (
    <BigModal
      handleClose={() => {
        setCloseModal(false);
      }}
      show={closeModal}
      containerClassName="addClients--modal"
      isModalOpen={closeModal}
      isVisible={closeModal}
      headerTitle={"View Contracts"}
    >
      <div className="mt-[40px]  flex flex-col gap-[30px] justify-center items-center w-[956px]">
        {/* {!addServiceSuccessful ? (
        <>
          {step === 1 && (
            <div className="flex flex-row gap-[12px] items-center justify-center w-full">
              <div className="flex flex-row gap-[5px] items-center justify-center flex-shrink-0">
                <Icon
                  id="add-business-info"
                  size={44}
                  className="flex-shrink-0"
                />
                <div className="flex flex-col gap-[5px] items-start justify-center">
                  <p className="text-[14px] font-[500] text-[#005397]">
                    Add Business Information
                  </p>
                  <p className="text-[12px] font-[500] text-[#5C6368]">
                    Provide details about the provider
                  </p>
                </div>
              </div>

              <div className="w-[100%] h-[1px] bg-[#005397]"></div>

              <div className="flex flex-row gap-[5px] items-center justify-center flex-shrink-0">
                <Icon
                  id="add-services-info-blue"
                  size={44}
                  className="flex-shrink-0"
                />
                <div className="flex flex-col gap-[5px] items-center justify-center">
                  <p className="text-[14px] font-[500] text-[#005397]">
                    Add Services & Pricing
                  </p>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="flex flex-row w-full justify-between items-center bg-[#F5fbff] rounded-[8px] border-l-8 border-[#005397] p-[16px] mx-[30px]">
          <p className="flex flex-row justify-start items-start text-[16px] leading-[150%] text-[#000B14] font-[500] gap-[12px] ">
            <span>
              <Icon id={"hintbulb"} height={"20"} width={"16"} />
            </span>
            Once you add provider info, they&apos;ll get an email to join the
            platform
          </p>
        </div>
      )} */}

        <div
          className={
            selectedCategory != "GYM" && formData?.serviceTypes?.length > 1
              ? "w-full flex flex-col p-[30px] border border-[#F5F5F5] rounded-[12px]"
              : "w-full"
          }
        >
          <form
            onSubmit={handleSubmit}
            className={`w-full flex flex-col gap-[16px] p-[30px] bg-[#F2F4F7] rounded-[12px] ${
              addServiceSuccessful ? "bg-transparent" : " bg-[#F2F4F7]"
            }`}
          >
            {formData?.serviceTypes?.length > 1 &&
              selectedCategory != "GYM" && (
                <div
                  onMouseEnter={() =>
                    step === 1 && setShowCategoryOptions(true)
                  }
                  onMouseLeave={() =>
                    step === 1 && setShowCategoryOptions(false)
                  }
                  className="relative cursor-pointer w-fit"
                >
                  <div className="flex flex-row justify-start items-center gap-[6px] mb-[14px]">
                    <p className="text-[16px] font-[600] leading-[100%] text-[#5C6368]">
                      <span>Category: </span>
                    </p>

                    <span
                      className={` px-[6px] py-[4px] rounded-[4px] font-[600] text-[12px] uppercase flex justify-center items-start ${
                        selectedCategory === "LAB"
                          ? "bg-[#EBF7EE] text-[#059023]"
                          : selectedCategory === "GYM"
                          ? "bg-[#E7F5FF] text-[#005397]"
                          : "bg-[#EAE3FF] text-[#7B4EF3]"
                      }`}
                    >
                      {" "}
                      <span>{selectedCategory}</span>{" "}
                      {step === 1 && (
                        <span
                          className={`transform ease-in-out duration-300 ${
                            showCategoryOptions ? "rotate-180" : ""
                          }`}
                        >
                          <Icon id="gray-caret-down-icon" size={16} />
                        </span>
                      )}
                    </span>
                  </div>
                  {showCategoryOptions && (
                    <div className="absolute top-[30px] right-0 flex flex-col justify-start items-start rounded-[8px] py-[10px] px-[10px] w-[129px] bg-white border border-[#F2F6F5] ">
                      {categoryOptions.map((option, index) => (
                        <span
                          onClick={() => handleCategoryChange(option)}
                          key={index}
                          className="text-[14px] py-[6px] px-[10px] font-[400] leading-[20px] text-[#5C6368] uppercase text-start w-full h-full hover:bg-[#F5F5F5] rounded-[4px] cursor-pointer"
                        >
                          {option}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              )}
            {selectedCategory === "GYM" ? (
              <div
                className={`w-full flex flex-col justify-start items-start gap-[20px] p-[30px] bg-[#fff] rounded-[12px] `}
              >
                <div className="w-full flex flex-row justify-between items-center cursor-pointer">
                  <div
                    onMouseEnter={() =>
                      step === 1 && setShowCategoryOptions(true)
                    }
                    onMouseLeave={() =>
                      step === 1 && setShowCategoryOptions(false)
                    }
                    className="relative cursor-pointer w-fit"
                  >
                    <div className="flex flex-row justify-start items-center gap-[6px] mb-[14px]">
                      <p className="text-[16px] font-[600] leading-[100%] text-[#5C6368]">
                        <span>Category: </span>
                      </p>

                      <span
                        className={` px-[6px] py-[4px] rounded-[4px] font-[600] text-[12px] uppercase flex justify-center items-start ${
                          selectedCategory === "LAB"
                            ? "bg-[#EBF7EE] text-[#059023]"
                            : selectedCategory === "GYM"
                            ? "bg-[#E7F5FF] text-[#005397]"
                            : "bg-[#EAE3FF] text-[#7B4EF3]"
                        }`}
                      >
                        {" "}
                        <span>{selectedCategory}</span>{" "}
                        {step === 1 && (
                          <span
                            className={`transform ease-in-out duration-300 ${
                              showCategoryOptions ? "rotate-180" : ""
                            }`}
                          >
                            <Icon id="gray-caret-down-icon" size={16} />
                          </span>
                        )}
                      </span>
                    </div>
                    {showCategoryOptions && (
                      <div className="absolute top-[30px] right-0 flex flex-col justify-start items-start rounded-[8px] py-[10px] px-[10px] w-[129px] bg-white border border-[#F2F6F5] ">
                        {categoryOptions.map((option, index) => (
                          <span
                            onClick={() => handleCategoryChange(option)}
                            key={index}
                            className="text-[14px] py-[6px] px-[10px] font-[400] leading-[20px] text-[#5C6368] uppercase text-start w-full h-full hover:bg-[#F5F5F5] rounded-[4px] cursor-pointer"
                          >
                            {option}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>{" "}
                <>
                  {step === 1 ? (
                    <div className="w-full flex flex-col justify-start items-start gap-[6px]">
                      <p className="text-[16px] font-600 leading-[100%] text-[#5C6368]">
                        Enter amount per visit for each person
                      </p>
                      <input
                        type="text"
                        name="gymAmount"
                        placeholder="₦ 0000 000"
                        value={formData.gymAmount}
                        onChange={(e) => handleChange(e, "gymAmount")}
                        onBlur={(e) => handleBlur(e, "gymAmount")}
                        className="w-full h-[56px] bg-transparent rounded-[8px] border border-[#D3D3D399] px-[24px] py-[18.5px] text-[16px] font-400 leading-[100%] text-#5C6368] focus:border-primary focus:box-shadow-[0 0 0 0.2rem rgba(#ff8788, 10%)]"
                      />
                      <div className="flex flex-row w-full justify-end items-center"></div>
                      <small className="font-[500] text-[12px] leading-[150%] text-[#ff0000] text-uppercase">
                        {touched.gymAmount && errors.gymAmount}
                      </small>
                    </div>
                  ) : (
                    <div className="w-full flex flex-row justify-start items-center bg-[#D3D3D399] rounded-[8px]">
                      <div className="flex-1 basis-[65%] flex flex-row justify-start items-center px-[24px] py-[12px] border-r border-[#D3D3D399]">
                        <p className="text-[14px] font-[500] leading-[100%] text-[#000B14]">
                          Enter amount per visit for each person
                        </p>
                      </div>
                      <div className="flex-1  min-w-fit flex flex-row justify-start items-center px-[24px] py-[12px]">
                        <div className="flex flex-row gap-[6px] items-center justify-end">
                          <span className="text-[14px] leading-[100%] font-[600] text-[#000B14]">
                            ₦ {formatNumberWithCommas(formData.gymAmount)}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              </div>
            ) : (
              <>
                {formData?.serviceTypes?.map((serviceTypeObj, index) => (
                  <>
                    <div
                      key={serviceTypeObj.id}
                      id={`service-type-container-${serviceTypeObj.id}`}
                      className={`w-full flex flex-col justify-start items-start gap-[20px] p-[30px] bg-[#fff] rounded-[12px] ${
                        Object.keys(errors).some((key) =>
                          key.includes(`-${serviceTypeObj.id}-`)
                        ) && openServiceTypeId != serviceTypeObj.id
                          ? "border border-red-500"
                          : formData.serviceTypes.length > 1 &&
                            openServiceTypeId === serviceTypeObj.id
                          ? "border border-[#005397]"
                          : ""
                      }`}
                    >
                      <div
                        className="w-full flex flex-row justify-between items-center cursor-pointer"
                        onClick={() => toggleServiceType(serviceTypeObj.id)}
                      >
                        {serviceTypeObj.serviceType &&
                        serviceTypeObj.id !== openServiceTypeId ? (
                          <div className="flex flex-row justify-start items-center gap-[6px]">
                            <p className="text-[16px] font-[600] leading-[100%] text-[#5C6368]">
                              <span>Service Type: </span>
                            </p>
                            <span className="text-[#000B14] px-[6px] py-[4px] rounded-[4px] font-[600] text-[16px] capitalize flex justify-center items-start bg-[#F5F5F5]">
                              {" "}
                              {serviceTypeObj.serviceType}
                            </span>
                          </div>
                        ) : (
                          <>
                            {formData.serviceTypes.length === 1 ? (
                              <div
                                onMouseEnter={() =>
                                  step === 1 && setShowCategoryOptions(true)
                                }
                                onMouseLeave={() =>
                                  step === 1 && setShowCategoryOptions(false)
                                }
                                className="relative cursor-pointer w-fit"
                              >
                                <div className="flex flex-row justify-start items-center gap-[6px] mb-[14px]">
                                  <p className="text-[16px] font-[600] leading-[100%] text-[#5C6368]">
                                    <span>Category: </span>
                                  </p>

                                  <span
                                    className={` px-[6px] py-[4px] rounded-[4px] font-[600] text-[12px] uppercase flex justify-center items-start ${
                                      selectedCategory === "LAB"
                                        ? "bg-[#EBF7EE] text-[#059023]"
                                        : selectedCategory === "GYM"
                                        ? "bg-[#E7F5FF] text-[#005397]"
                                        : "bg-[#EAE3FF] text-[#7B4EF3]"
                                    }`}
                                  >
                                    {" "}
                                    <span>{selectedCategory}</span>{" "}
                                    {step === 1 && (
                                      <span
                                        className={`transform ease-in-out duration-300 ${
                                          showCategoryOptions
                                            ? "rotate-180"
                                            : ""
                                        }`}
                                      >
                                        <Icon
                                          id="gray-caret-down-icon"
                                          size={16}
                                        />
                                      </span>
                                    )}
                                  </span>
                                </div>
                                {showCategoryOptions && (
                                  <div className="absolute top-[30px] right-0 flex flex-col justify-start items-start rounded-[8px] py-[10px] px-[10px] w-[129px] bg-white border border-[#F2F6F5] ">
                                    {categoryOptions.map((option, index) => (
                                      <span
                                        onClick={() =>
                                          handleCategoryChange(option)
                                        }
                                        key={index}
                                        className="text-[14px] py-[6px] px-[10px] font-[400] leading-[20px] text-[#5C6368] uppercase text-start w-full h-full hover:bg-[#F5F5F5] rounded-[4px] cursor-pointer"
                                      >
                                        {option}
                                      </span>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="flex flex-row justify-start items-center gap-[6px]">
                                <p className="text-[16px] font-[600] leading-[100%] text-[#5C6368]">
                                  <span>Service Type: </span>
                                </p>
                                {serviceTypeObj.serviceType && (
                                  <span className="text-[#000B14] px-[6px] py-[4px] rounded-[4px] font-[600] text-[16px] capitalize flex justify-center items-start bg-[#F5F5F5]">
                                    {" "}
                                    {serviceTypeObj.serviceType}
                                  </span>
                                )}
                              </div>
                            )}
                          </>
                        )}

                        {formData.serviceTypes.length > 1 && (
                          <span
                            className={`transform transition-transform duration-300 ease-in-out ${
                              openServiceTypeId === serviceTypeObj.id
                                ? "rotate-180"
                                : ""
                            }`}
                          >
                            <Icon id={"caret-down"} size={16} />
                          </span>
                        )}
                      </div>

                      {openServiceTypeId === serviceTypeObj.id && (
                        <>
                          {" "}
                          {step === 1 && (
                            <div className="w-full flex flex-col justify-start items-start gap-[6px]">
                              <p className="text-[16px] font-600 leading-[100%] text-[#5C6368]">
                                Enter Service Type
                              </p>
                              <input
                                type="text"
                                name="serviceType"
                                placeholder="Enter Service Type"
                                value={serviceTypeObj.serviceType}
                                disabled={providerContract?.id}
                                onChange={(e) =>
                                  handleChange(e, serviceTypeObj.id)
                                }
                                onBlur={(e) => handleBlur(e, serviceTypeObj.id)}
                                className="w-full h-[56px] bg-transparent rounded-[8px] border border-[#D3D3D399] px-[24px] py-[18.5px] text-[16px] font-400 leading-[100%] text-#5C6368] focus:border-primary focus:box-shadow-[0 0 0 0.2rem rgba(#ff8788, 10%)]"
                              />
                              <small className="font-[500] text-[12px] leading-[150%] text-[#ff0000] text-uppercase">
                                {touched[`serviceType-${serviceTypeObj.id}`] &&
                                  errors[`serviceType-${serviceTypeObj.id}`]}
                              </small>
                            </div>
                          )}
                          {serviceTypeObj?.services?.map((service, index) => (
                            <>
                              {step === 1 ? (
                                <div
                                  key={index}
                                  className="w-full flex flex-row justify-start items-start gap-[20px]"
                                >
                                  <div className="w-3/4 flex flex-col justify-start items-start gap-[6px]">
                                    <p className="text-[16px] font-600 leading-[100%] text-[#5C6368]">
                                      Enter Service Name
                                    </p>
                                    <input
                                      type="text"
                                      name="serviceName"
                                      placeholder="Enter Service Name"
                                      disabled={providerContract?.id}
                                      value={service.serviceName}
                                      onChange={(e) =>
                                        handleChange(
                                          e,
                                          serviceTypeObj.id,
                                          index
                                        )
                                      }
                                      onBlur={(e) =>
                                        handleBlur(e, serviceTypeObj.id, index)
                                      }
                                      className="w-full h-[56px] bg-[#fff] rounded-[8px] border border-[#D3D3D399] px-[24px] py-[18.5px] text-[16px] font-400 leading-[100%] text-#5C6368] focus:border-primary focus:box-shadow-[0 0 0 0.2rem rgba(#ff8788, 10%)]"
                                    />
                                    <small className="font-[500] text-[12px] leading-[150%] text-[#ff0000] text-uppercase">
                                      {touched[
                                        `serviceName-${serviceTypeObj.id}-${index}`
                                      ] &&
                                        errors[
                                          `serviceName-${serviceTypeObj.id}-${index}`
                                        ]}
                                    </small>
                                  </div>

                                  <div className="w-1/4 flex flex-col justify-start items-start gap-[6px]">
                                    <p className="text-[16px] font-600 leading-[100%] text-[#5C6368]">
                                      Enter Amount
                                    </p>
                                    <input
                                      type="text"
                                      name="amount"
                                      placeholder="Enter Amount"
                                      value={service.amount}
                                      onChange={(e) =>
                                        handleChange(
                                          e,
                                          serviceTypeObj.id,
                                          index
                                        )
                                      }
                                      onBlur={(e) =>
                                        handleBlur(e, serviceTypeObj.id, index)
                                      }
                                      className="w-full h-[56px] bg-[#fff] rounded-[8px] border border-[#D3D3D399] px-[24px] py-[18.5px] text-[16px] font-400 leading-[100%] text-#5C6368] focus:border-primary focus:box-shadow-[0 0 0 0.2rem rgba(#ff8788, 10%)]"
                                    />
                                    {/* <div
                                    className="flex w-full flex-row justify-between items-center relative"
                                    onMouseEnter={() =>
                                      setTooltipVisibleID(
                                        `${serviceTypeObj.id}-${index}`
                                      )
                                    }
                                    onMouseLeave={() =>
                                      setTooltipVisibleID(null)
                                    }
                                  >
                                    <p className="text-[14px] font-400 leading-[18px] text-[#5C6368] flex flex-row justify-start items-center gap-[6px]">
                                      <span className="pl-[4px]">
                                        <Icon id="gray-info-icon-2" size={14} />
                                      </span>
                                      Est. Total
                                    </p>
                                    <p className="text-[14px] font-400 leading-[18px] text-[#5C6368]">
                                      ₦ {calculateEstTotal(service.amount)}
                                    </p>

                                    {tooltipVisibleID ===
                                      `${serviceTypeObj.id}-${index}` && (
                                      <div className="absolute top-[30px] right-0 w-[360px] flex flex-col items-end z-10 shadow-[0px_20px_25px_-5px_rgba(51,65,85,0.1),0px_10px_10px_-5px_rgba(51,65,85,0.04)]">
                                        <div className="absolute w-[28px] h-[16px] left-[calc(50%-14px)] top-[-14px]">
                                          <div className="w-0 h-0 border-l-[14px] border-l-transparent border-r-[14px] border-r-transparent border-b-[16px] border-b-[#F5FBFF]"></div>
                                        </div>
                                        <div className="w-full p-[16px_16px_12px] gap-[6px] bg-[#F5FBFF] rounded-[8px] flex flex-col items-start">
                                          <div className="flex flex-row items-center gap-[10px]">
                                            <p className="font-[600] text-[16px] leading-[24px] text-[#000B14]">
                                              Est. Total
                                            </p>
                                          </div>
                                          <p className="font-[400] text-[14px] leading-[24px] text-[#5C6368]">
                                            A 10% service fee is added on top of
                                            the price you enter. The provider
                                            receives the full amount you&apos;ve
                                            agreed on.
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </div> */}
                                    <small className="font-[500] text-[12px] leading-[150%] text-[#ff0000] text-uppercase">
                                      {touched[
                                        `amount-${serviceTypeObj.id}-${index}`
                                      ] &&
                                        errors[
                                          `amount-${serviceTypeObj.id}-${index}`
                                        ]}
                                    </small>
                                  </div>
                                </div>
                              ) : (
                                <div className="w-full flex flex-row justify-start items-center bg-[#D3D3D399] rounded-[8px]">
                                  <div className="flex-1 basis-[65%] flex flex-row justify-start items-center px-[24px] py-[12px] border-r border-[#D3D3D399]">
                                    <p className="text-[14px] font-[500] leading-[100%] text-[#000B14]">
                                      {service.serviceName}
                                    </p>
                                  </div>
                                  <div className="flex-1  min-w-fit flex flex-row justify-start items-center px-[24px] py-[12px]">
                                    <div className="flex flex-row gap-[6px] items-center justify-end">
                                      <span className="text-[14px] leading-[100%] font-[600] text-[#000B14]">
                                        ₦{" "}
                                        {formatNumberWithCommas(service.amount)}
                                      </span>
                                      {/* <span className="w-[2px] h-[19px] bg-[#9DA1A4]" /> */}
                                      {/* <Icon id={"gray-info-icon"} size={14} /> */}

                                      {/* <span className="text-[12px] leading-[18px] font-[400] text-[#5C6368]">
                                      Est. Total
                                    </span>

                                    <span className="text-[12px] leading-[18px] font-[400] text-[#5C6368]">
                                      ₦{" "}
                                      {formatNumberWithCommas(
                                        calculateEstTotal(service.amount)
                                      )}
                                    </span> */}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ))}
                        </>
                      )}
                    </div>

                    {index !== formData.serviceTypes.length - 1 && (
                      <div className="w-full h-[1px] bg-[#D3D3D380]"></div>
                    )}
                  </>
                ))}

                {step === 1 ? (
                  <>
                    {" "}
                    {!providerContract?.id && (
                      <button
                        type="button"
                        onClick={addNewServiceType}
                        style={{ border: "1px solid #005397" }}
                        className="w-full flex justify-center items-center border border-[#005397] bg-white rounded-[8px] px-[24px] py-[10px] text-[16px] font-[600] tracking-[2%] leading-[100%] text-[#005397]"
                      >
                        <span>
                          <Icon id="blue-plus-sign" size={24} />
                        </span>
                        <span>Add Another Service Type</span>
                      </button>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </>
            )}

            <Button variant={"primary"} size={"md"} type="submit">
              {step === 1 ? "Continue" : `Close `}
            </Button>
            {/* {addServiceSuccessful && (
              <AddServicesandPricingSuccessModal
                setShowAcceptedModal={setAddServiceSuccessful}
                showAcceptedModal={addServiceSuccessful}
                businesName={providerContract?.resellerName}
              />
            )} */}
          </form>
        </div>
      </div>
    </BigModal>
  );
};

export default ViewContractModal;
